<template>

<!-- Modal -->
<div class="modal" id="spinnerModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content ">
      <div style="color:blue" class="modal-header">
        <div v-if="btn">  
        <h4 class="modal-title" id="staticBackdropLabel">
            <i style="color:red" class="fas fa-exclamation-circle mr-3" aria-hidden="true"></i>     
             ATTENZIONE 
        </h4> 
        </div>
        <div v-else>
        <h4 class="modal-title" id="staticBackdropLabel">
            <i style="color:blue" class="fas fa-save  mr-3" aria-hidden="true"></i>     
             Registrazione prodotto ... 
        </h4>     
        
        </div>    
      </div>
      <div style="color:black" class="modal-body">
          <div v-if="!btn" class="text-center">
            <div class="spinner-grow text-success" style="width: 3rem; height: 3rem;" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        
        
        <div v-else>
            <slot name="body1"></slot> 
            <slot name="body2"></slot>        
        </div>      
        
        
      </div>
      <div class="modal-footer">
        <!--<button type="button" class="btn btn-secondary" data-dismiss="modal">NO</button>-->
        <button v-if="btn" @click="$emit('close')" type="button" data-dismiss="modal" class="btn btn-primary">RIPROVA</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>


export default {
   props : ['btn'],
  components: {},
  data() {
    return {
    
    
      
    };
  },
   
  methods: 
  {
  }  
    
   

}
</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 18px;  
}
small {
  font-family  : 'Roboto Condensed';
  font-size    : 15px;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;

}
.modal-footer {  
  justify-content: space-between;  
}
</style>


